import { cn } from "@tellescope/design-system";
import { BlockProps } from "../../../types";
import { useRelatedContactsBlock } from "../../../hooks";
import { BlockHeader } from "../BlockHeader";
import { RelatedContactsFilterPopover } from "./RelatedContactsFilterPopover";
import { RelatedContactsListView } from "./RelatedContactsListView";
import { RelatedContactsAddView } from "./RelatedContactsAddView";

export const RelatedContactsBlock = ({
  onMaximize,
  alwaysShowButtons = false,
  className,
  contentClassName,
  onChangeEnduser,
  ...rest
}: BlockProps) => {
  const {
    parsedInfo,
    mode,
    openAddView,
    closeAddView,
    enduserId,
    relationships,
    relationshipIds,
    filterBlock,
    filterFieldOptions,
    relationshipSelectOptions,
    onFilterChange,
    updateEnduserMutation,
    isEditingTitle,
    setIsEditingTitle,
    newTitle,
    setNewTitle,
    editMode,
    setEditMode,
    updateInfo,
    duplicateBlock,
    deleteBlock,
    toggleExpanded,
    expanded,
    blockLayout,
    canEditTitle,
    canEditBlock,
    canCreateBlock,
    canDeleteBlock,
    canEditEnduser,
  } = useRelatedContactsBlock({ ...rest, onMaximize, alwaysShowButtons, className, onChangeEnduser });

  return (
    <div className={cn("group", className)}>
      <BlockHeader
        editMode={editMode}
        setEditMode={setEditMode}
        isEditingTitle={isEditingTitle}
        setIsEditingTitle={setIsEditingTitle}
        newTitle={newTitle}
        setNewTitle={setNewTitle}
        canEditTitle={canEditTitle}
        parsedInfo={parsedInfo}
        updateInfo={updateInfo}
        duplicateBlock={duplicateBlock}
        deleteBlock={deleteBlock}
        canCreateBlock={canCreateBlock}
        canDeleteBlock={canDeleteBlock}
        onMaximize={onMaximize}
        alwaysShowButtons={alwaysShowButtons}
        actions={
          canEditBlock && (
            <RelatedContactsFilterPopover
              filterBlock={filterBlock}
              fieldOptions={filterFieldOptions}
              relationshipOptions={relationshipSelectOptions}
              onFilterChange={onFilterChange}
            />
          )
        }
      />

      {mode === "add" ? (
        <RelatedContactsAddView
          enduserId={enduserId}
          relationshipIds={relationshipIds}
          updateEnduserMutation={updateEnduserMutation}
          closeAddView={closeAddView}
          contentClassName={contentClassName}
        />
      ) : (
        <RelatedContactsListView
          enduserId={enduserId}
          relationships={relationships}
          filterBlock={filterBlock}
          updateEnduserMutation={updateEnduserMutation}
          openAddView={openAddView}
          editMode={editMode}
          setEditMode={setEditMode}
          expanded={expanded}
          toggleExpanded={toggleExpanded}
          blockLayout={blockLayout}
          canEditEnduser={canEditEnduser}
          contentClassName={contentClassName}
          onChangeEnduser={onChangeEnduser}
        />
      )}
    </div>
  );
};
